import { api } from "./api";

export const writeBeliefsAI = (data) =>
  api.post("/ai/write-beliefs", data).then((r) => r.data);

export const generateStoriesAI = (data) =>
  api.post("/ai/generate-stories", data).then((r) => r.data);

export const basicBlogAI = (data) =>
  api.post("/ai/blog/basic", data).then((r) => r.data);

export const aeoBlogAI = (data) =>
  api.post("/ai/blog/aeo", data).then((r) => r.data);

export const liveVideoScriptAI = (data) =>
  api.post("/ai/live-video-script", data).then((r) => r.data);

export const contentBatchAI = (data) =>
  api.post("/ai/content-batch", data).then((r) => r.data);

export const bulkCreateBeliefs = (drafts) =>
  api.post("/beliefs/bulk", { drafts }).then((r) => r.data);

export const createStoryDrafts = (belief_id, drafts) =>
  api.post("/stories/drafts", { belief_id, drafts }).then((r) => r.data);

export const approveStory = (story_id) =>
  api.post(`/stories/${story_id}/approve`).then((r) => r.data);

export const rejectStory = (story_id) =>
  api.delete(`/stories/${story_id}/reject`).then((r) => r.data);

export const saveContentPiece = (data) =>
  api.post("/content-library", data).then((r) => r.data);

export const listContentPieces = () =>
  api.get("/content-library").then((r) => r.data);

export const getContentPiece = (id) =>
  api.get(`/content-library/${id}`).then((r) => r.data);

export const deleteContentPiece = (id) =>
  api.delete(`/content-library/${id}`).then((r) => r.data);
